<template>
    <footer class="footer"
            :class="{fadeInUp: isVisible}"
            v-observe-visibility="{
                callback: visibilityChanged,
                throttle: 300,
                intersection: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: 0
                }
           }">
        <div v-if="footerOptions" class="footer-container" >
            <div class="footer-info" >
                <div class="column logo-column">
                    <footer-logo />
                </div>
                <div v-if="footerOptions.show_contact_column"
                     class="column contact-column">
                    <section-heading :text="footerOptions.contact_column_title" />
                    <a :href="`tel:${phone}`" class="phone">
                        {{ phone }}
                    </a>
                    <social-media />
                </div>
                <div v-if="footerOptions.show_location_column"
                     class="column location-column">
                    <section-heading :text="footerOptions.location_column_title" />
                    <a :href="googleMaps" class="address">
                        <p>{{ address.street }}</p>
                        <p>{{ address.city }}, {{ address.state }} {{ address.zip }}</p>
                    </a>
                </div>
                <div v-if="footerOptions.show_hours_column"
                     class="column hours-column">
                    <section-heading :text="footerOptions.hours_column_title" />
                    <div class="hours" v-html="hours"></div>
                </div>
                <div class="scroll-up-button">
                    <div class="bounce-up"
                         v-scroll-to="{ element: 'body', duration: 1000, offset: 0 }">
                        <font-awesome-icon class="up-arrow" :icon="upArrow" />
                    </div>
                </div>
            </div> 
            <hr >
            <div class="footer-copyright" >
                <div class="copyright">
                    {{ footerOptions.copyright }}
                </div>
                <div class="byline" v-html="footerOptions.powered_by"></div>
            </div>
        </div>
    </footer>
</template>

<script>
    import FooterLogo from './FooterLogo'
    import SocialMedia from './SocialMedia'
    import SectionHeading from '../components/SectionHeading'
    import EqualHousingSvg from '../svgs/EqualHousingSvg'
    import {faChevronUp} from '@fortawesome/pro-regular-svg-icons/faChevronUp'

    export default {
        name: "ThemeFooter",
        components: {
            FooterLogo,
            SectionHeading,
            SocialMedia,
            EqualHousingSvg
        },
        data() {
            return {
                isVisible: false,
                logoHoverOn: false,
                footerOptions: wp.settings.footerOptions,
                phone: wp.settings.phoneNumber,
                hours: wp.settings.hours,
                address: wp.settings.address,
                googleMaps: wp.settings.google_maps_address_link
            }
        },
        computed: {
            upArrow() {
                return faChevronUp
            }
        },
        methods: {
            visibilityChanged(isVisible) {
                if (!this.isVisible) this.isVisible = isVisible
            },
        },
        // watch: {
        //     $route: {
        //         deep: true,
        //         immediate: true,
        //         handler(val, oldVal) {
        //             this.isVisible = false;
        //         }
        //     }
        // }
    }
</script>

<style lang="scss" scoped>

    // Fade In Up
    .fadeInUp {
        animation-duration: 1s;
        animation-fill-mode: both;
        -webkit-animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        -webkit-animation-name: fadeInUp;
        animation-name: fadeInUp;
    }
    @-webkit-keyframes fadeInUp {
        from {
            transform: translate3d(0,40px,0)
        }
        to {
            transform: translate3d(0,0,0);
            opacity: 1
        }
    }
    @keyframes fadeInUp {
        from {
            transform: translate3d(0,40px,0)
        }

        to {
            transform: translate3d(0,0,0);
            opacity: 1
        }
    }

    .footer {
        opacity: 0;
        position: relative;
        background-color: $white;
        width: 100%;

        a {
            color: #000;
            text-decoration: none;

            &:hover {
                cursor: pointer;
                color: $theme-orange;
            }
        }
    }

    .footer-container {
        padding: 80px 40px 40px;
        @include site-container;
        @media (min-width: $site-container-width) {
            padding: 80px 0;
        }

        @media (max-width: $bp-mobile) {
            padding: 80px 20px 40px;
        }
    }

    .footer-info {
        display: flex;

        @media (max-width: $bp-medium) {
            flex-direction: column;
            width: min-content;
            margin: 0 auto;
        }

        .column {
            flex: 1;

            @media (max-width: $bp-medium) {
                margin-top: 40px;

                &:first-child {
                    margin-top: 0;
                }
            }
        }

        /deep/ .section-heading {
            margin-bottom: 20px;
        }
    }

    hr {
        margin-top: 80px;
        border-width: .5px;
        border-color: $theme-blue;

        @media (max-width: $bp-medium) {
            margin-top: 30px;
        }
    }

    .footer-copyright {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        @media (max-width: $bp-mobile) {
            flex-direction: column;
        }
    }

    .scroll-up-button {
        font-size: 20px;

        &:hover {
            cursor: pointer;
            color: $theme-orange
        }

        @media (max-width: $bp-medium) {
            margin: 40px 0 10px;
            text-align: center;
        }
    }

    .copyright, .byline {
        color: #000;
        font-size: 14px;

        svg {
            margin-left: 10px;
        }
    }

</style>

<style lang="scss">

    .hours {
        p {
            color: #000;
        }

        strong {
            margin-left: 5px;
        }
    }

    .byline {
        a {
            color: #000;
            font-weight: 600;
            &:hover {
                color: $theme-orange;
            }
        }

        @media (max-width: $bp-mobile) {
            margin-top: 10px;
        }
    }

</style>